module.exports = "/images/italic-icon.svg?64a877c9bc265567adb4632b859528cc";